export default __webpack_public_path__ + "cover_platinum.7dbebb42.png";